import { defaultTheme } from 'constants/theme/defaultTheme';
import styled from 'styled-components';
import { breakpoints } from 'stylesheet';

export const Styles = {
  Wrapper: styled.div`
    background-color: ${defaultTheme.colors.white};
    border-radius: 16px;
    width: 435px;
    height: 100%;
    min-height: 670px;
    display: flex;
    flex-direction: column;

    @media (max-width: ${breakpoints.small}) {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      border-radius: 0;
      width: 100%;
    }
  `,
  Heading: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid ${defaultTheme.colors.separator};
    padding: ${defaultTheme.spacing(5)};
  `,
  TickWrapper: styled.div`
    background-color: ${defaultTheme.colors.healthBlue};
    width: 80px;
    height: 80px;
    border-radius: 40px;
  `,
  Content: styled.div`
    padding: ${defaultTheme.spacing(6)};
    height: 100%;
  `,
  ConfirmContent: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex-grow: 1;
    padding: ${defaultTheme.spacing(6)};
  `,
  Guidance: styled.div<{ float: 'left' | 'right' }>`
    float: ${props => props.float};
  `,
  Close: styled.div`
    cursor: pointer;
  `,
  Button: styled.div`
    width: 100%;
    border-top: 1px solid ${defaultTheme.colors.separator};
    padding: ${defaultTheme.spacing(6)};
  `,
};
